import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Alert, AlertProps } from "antd";
import { FC } from "react";

type AuthAlertProps = Omit<AlertProps, "showIcon" | "icon">;

export const AuthAlert: FC<AuthAlertProps> = ({ style, ...props }) => {
    return (
        <Alert
            showIcon
            icon={<ExclamationCircleOutlined />}
            style={{
                border: "none",
                boxShadow: "0px 3px 6px -4px #0000001F",
                ...style,
            }}
            {...props}
        />
    );
};
